import dayjs from 'dayjs';

/**
 * 解析 agendasTime 为起止时间，格式如 "2026-06-05 09:00-2026-06-05 13:00"
 * 页面会议时间仅展示到分钟，因此统一清除接口中可能存在的秒和毫秒
 */
export function parseAgendasTimeRange(agendasTime) {
    if (!agendasTime) {
        return null;
    }
    const dateTimesArr = agendasTime.split(/-(?=\d{4})/) || [];
    if (dateTimesArr.length !== 2) {
        return null;
    }
    const start = dayjs(dateTimesArr[0].trim()).startOf('minute');
    const end = dayjs(dateTimesArr[1].trim()).startOf('minute');
    if (!start.isValid() || !end.isValid()) {
        return null;
    }
    return { start, end };
}

/**
 * 判断两个时间段是否存在重叠（首尾相接不算重叠，如 18:00-19:00 与 19:00-20:00）
 */
export function isTimeRangeOverlap(rangeA, rangeB) {
    if (!rangeA || !rangeB) {
        return false;
    }
    return rangeA.start.isBefore(rangeB.end) && rangeB.start.isBefore(rangeA.end);
}

/** 从场次对象解析 placeId（列表接口可能只返回 place 名称） */
export function resolveHallPlaceId(hall, placeArrList) {
    if (!hall) {
        return null;
    }
    const rawPlaceId = hall.placeId;
    if (rawPlaceId && Number(rawPlaceId) > 0) {
        return Number(rawPlaceId);
    }
    if (hall.place && Array.isArray(placeArrList) && placeArrList.length) {
        const matched = placeArrList.find(p => p.name === hall.place);
        return matched?.id ?? null;
    }
    return null;
}

/** 收集某天所有叶子场次；有子场次的一级会议仅作分类，不计入地点占用 */
export function getLeafHallsOnDate(conferenceData, date) {
    if (!conferenceData || !date) {
        return [];
    }
    const mainHalls = conferenceData[date] || [];
    const leafHalls = [];
    mainHalls.forEach(mainHall => {
        if (mainHall.secondHallsList?.length) {
            mainHall.secondHallsList.forEach(subHall => {
                leafHalls.push(subHall);
            });
            return;
        }
        leafHalls.push(mainHall);
    });
    return leafHalls;
}

/**
 * 获取同一天、与当前场次时间段存在重叠的会议地点 ID 集合
 * 隐藏场次同样占用；excludeHallId 排除当前编辑场次，使其已选地点保持可选；
 * 首尾相接（如上一场 18:00-19:00，下一场 19:00-20:00）不算重叠，地点可继续选择
 */
export function getOccupiedPlaceIds({ conferenceData, date, agendasTime, placeArrList, excludeHallId }) {
    const currentRange = parseAgendasTimeRange(agendasTime);
    if (!currentRange || !date) {
        return new Set();
    }
    const occupied = new Set();
    const halls = getLeafHallsOnDate(conferenceData, date);
    halls.forEach(hall => {
        if (excludeHallId && hall.id === excludeHallId) {
            return;
        }
        const hallRange = parseAgendasTimeRange(hall.agendasTime);
        if (!isTimeRangeOverlap(currentRange, hallRange)) {
            return;
        }
        const placeId = resolveHallPlaceId(hall, placeArrList);
        if (placeId) {
            occupied.add(placeId);
        }
    });
    return occupied;
}
